import React from 'react';
import logo from '../../assets/images/footer/footer-logo.png';
import ios_ps from '../../assets/images/footer/ios_appStore.svg';
import android_ps from '../../assets/images/footer/andriod_playStore.svg';

class SuccessFooter extends React.Component {
  render() {
    return (
      <footer>
        <section className="cmx-success-footer">
          <section className="lft-side">
            <p>© 2022 CMX Cinemas</p>
          </section>
          <section className="center-side">
              <aside className='playstore'>
                <aside className='logo'>
                  <figure>
                    <a href="javascript:;" title='CMX'><img src={logo} alt="CMX logo" className="img-fluid" /></a>
                  </figure>
                </aside>
                <figure className='ps-images'>
                  <span>Download CMX App</span>
                  <a href="https://apps.apple.com/us/app/cmx-cinemas/id1556073550" target="_blank" title='App Store'><img src={ios_ps} alt="IOS App Store" className="img-fluid" /></a>
                  <a href="https://play.google.com/store/apps/details?id=com.influx.cinema.cmx" target="_blank" title='Google Play'><img src={android_ps} alt="Android App Store" className="img-fluid" /></a>
                </figure>
              </aside>
          </section>
          <section className="rgt-side">
            <p><a href='https://myinfinity.co/direct/' target="_blank" title='Powered by influx'>Powered by influx</a></p>
          </section>
        </section>
      </footer>
    )
  }
}

export default SuccessFooter;